import { ActionEntry } from "../../ActionEntries";

export const ApplyCostScaleChange = (
  action: ActionEntry,
  newActions: Map<string, ActionEntry>,
  amount: number = 1,
) => {
  // ApplyCostScaleChange
  // Increments costScale by amount (default 1)
  // For bulk purchases, amount = buyAmount
  newActions.get(action.id)!.costScale += amount;
  return newActions;
};
